import { render, staticRenderFns } from "./group-qq.vue?vue&type=template&id=dfac6a52&scoped=true&"
import script from "./group-qq.vue?vue&type=script&lang=js&"
export * from "./group-qq.vue?vue&type=script&lang=js&"
import style0 from "./group-qq.vue?vue&type=style&index=0&lang=css&"
import style1 from "./group-qq.vue?vue&type=style&index=1&id=dfac6a52&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfac6a52",
  null
  
)

export default component.exports